import { Snackbar, Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { app_actions } from '../actions/app_actions';
const SnackBarAlert = () => {
    const dispatch = useDispatch();
    const snackBarMsg = useSelector((state) => state.ui.snackBarMsg);
    const [snackBar, setSnackBar] = useState(true);
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(app_actions.snackbarMessage(''));
        setSnackBar(false);
    };
    useEffect(() => {
        if (snackBarMsg !== '') {
            setSnackBar(true);
        }
    }, [snackBarMsg]);
    if (snackBarMsg === '') {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Snackbar, { open: snackBar, autoHideDuration: 3000, onClose: handleClose, className: 'message-error' },
        React.createElement(Alert, { onClose: handleClose, severity: "error", sx: { width: '100%' } }, snackBarMsg)));
};
export default SnackBarAlert;
